import React from 'react';
import withRouter from "../utils/withRouter";
import HeaderTwo from '../common/header/HeaderTwo';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import BussinessDetail from '../components/bussiness/BussinessDetail';
import ContactMap from '../components/contact/ContactMap';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const Contact = (props) => {
    const id = props.location?.state?.id;
    return (
        <>
            <HeaderOne />

            <BussinessDetail businessId={id} />

            <FooterOne />
        </>
    )
}

export default withRouter(Contact);